module.exports = __webpack_public_path__ + "static/media/response_rate.59cb8f06.png";